var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',{staticClass:"title is-3"},[_vm._v("Agregar Contacto")]),_c('form-cliente',{attrs:{"cliente":_vm.datosCliente},on:{"registrar":_vm.onRegistrar}}),_c('b-loading',{attrs:{"is-full-page":true,"can-cancel":false},model:{value:(_vm.cargando),callback:function ($$v) {_vm.cargando=$$v},expression:"cargando"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }